import { LinkComponentType } from "@made-people/grease-link";
import { GreaseRemixLink } from "@made-people/grease-remix";
import { overlayEventEmitter } from "@made-people/blueprint-overlay";

type MissMaryLinkProps = {
  context?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const MissMaryLink: LinkComponentType = (
  props: MissMaryLinkProps & React.ComponentProps<typeof GreaseRemixLink>,
) => {
  return (
    <GreaseRemixLink
      {...props}
      onClick={(e) => {
        overlayEventEmitter.emit("close", {});
        props.onClick && props.onClick(e);
      }}
    />
  );
};
